// import React, { useState, useEffect } from 'react';
// import { fineArts } from '../../fineArts';
// import styles from './styles.module.scss';
// import Spinner from 'react-bootstrap/Spinner';
// import Image from 'react-bootstrap/Image';
// import { useNavigate } from 'react-router';

// export default function StorePage() {

//     const [isLoading, setIsLoading] = useState(true);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setIsLoading(false);
//         }, 2000);

//         return () => clearTimeout(timer);
//     }, []);

//     const redirectToContact = () => {
//         navigate('/contact');
//     }

//     const handleImageClick = (id) => {
//         navigate(`/fine-arts/${id}`);
//       };

//     if(isLoading) {
//         return(
//             <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center">
//             <Spinner animation="border" role="status">
//               <span className="visually-hidden">Laster inn...</span>
//             </Spinner>
//           </div>
//         )
//     }

//     return(
//         <div className={`home-container col-12 d-flex flex-column`}>
//             {/* <h1 className="text-center my-5">Fine Art</h1> */}
//             <div className={`text-black text-center col-11 m-auto col-md-6 ${styles.intro} mb-5`}>
//                 This is my artwork which I would like to share with you – limited edition, museum quality Giclée prints.
//                 <br></br>
//                 All prints are available in different sizes and printed on Hahnemühle paper.
//                 <br></br>
//                 My artworks can be ordered as prints or framed.
//                 <br></br>
//                 <div className={styles.contactDiv}>
//                     For further information on sizes, editions and prices, 
//                     <span className={styles.contactLink} onClick={redirectToContact}>
//                        use contact form
//                     </span> 
//                     or call me +4796745992
//                 </div>
//             </div>
//             <div className={styles.masonryLayout}>
//                 {fineArts.map((image, index) => (
//                     <div className={styles.mansorySub}>
//                         <div key={index} className={styles.masonryItem} onClick={()=> {handleImageClick(image.id)}}>
//                             <div className={styles.overlay}>
//                             </div>
//                             <Image className={styles.imageCard} fluid src={image.url} alt="img" />
//                         </div>
//                         <div className={styles.nameDiv}>
//                             {image.name}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     )
// }


import React from 'react';
import Unavailable from '../../components/unavailable';
import { useContent } from '../../content/ContentProvider';
import Picture, { SIZES } from '../../components/picture';
import styles from './styles.module.scss';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router';

export default function StorePage() {
  const navigate = useNavigate();
  const { status, fineArts } = useContent();

  const redirectToContact = () => {
    navigate('/contact');
  };

  const handleImageClick = (id) => {
    navigate(`/fine-arts/${id}`);
  };

  if (status === 'loading') {
    return (
      <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Laster inn...</span>
        </Spinner>
      </div>
    );
  }

  if (status === 'error') {
    return <Unavailable />;
  }

  return (
    <div className={`home-container col-12 d-flex flex-column`}>
      <div className={`text-black text-center col-11 m-auto col-md-6 ${styles.intro} mb-5`}>
        This is my artwork which I would like to share with you – limited edition, museum quality Giclée prints.
        <br />
        All prints are available in different sizes and printed on Hahnemühle paper.
        <br />
        My artworks can be ordered as prints or framed.
        <br />
        <div className={styles.contactDiv}>
          For further information on sizes, editions and prices,
          <span className={styles.contactLink} onClick={redirectToContact}>
            {' '}use contact form
          </span>
          {' '}or call me +4796745992
        </div>
      </div>

      <div className={styles.masonryLayout}>
        {fineArts.map((image, index) => {
          const first = image.images[0];

          if (!first) return null; // safety

          return (
            <div key={image.id} className={styles.mansorySub}>
              <div
                className={styles.masonryItem}
                onClick={() => handleImageClick(image.id)}
              >
                <div className={styles.overlay} />
                <Picture
                  className={`img-fluid ${styles.imageCard}`}
                  image={first}
                  sizes={SIZES.fineArtList}
                  priority={index < 2}
                  fade
                  alt={image.name}
                />
              </div>
              <div className={styles.nameDiv}>
                {image.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
